import { Rate } from "antd";
import "./ReviewCard.scss";
import { IReview } from "types/common";

export const ReviewCard: React.FC<IReview> = ({
  rating,
  review,
  name,
  image,
  designation,
}) => {
  return (
    <div className="card">
      <Rate allowHalf value={rating} disabled style={{color: '#175ADB'}} />
      <p className="text">{review}</p>

      <div className="person-details">
        {image ? (
          <img src={image} className="avatar" />
        ) : (
          <div className="avatar-placehorlder" />
        )}
        <div>
          <h5 className="name">{name}</h5>
          <h5 className="designation">{designation}</h5>
        </div>
      </div>
    </div>
  );
};
